const ssl = true
const sequre = ssl ? 'https://' : 'http://'
export const baseUrl = sequre + 'next.menupoly.com/api'
//export const stripeToken = 'pk_test_lK9Utd3owMXYjNt3Ufm78ecN'
export const stripeToken = 'pk_live_obSYSIXeYgW5YQeoSUsPUZni'
export const clientDashboard = '/clientdashboard'
export const fileUrl = 'https://next.menupoly.com'


